import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'admin-buyer-configuration-ingest-all-invoices',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Ingest All Invoices"
            sectionFormControlName="ingestAllInvoicesEnabled"
            [sectionFormGroup]="ingestAllInvoicesFormGroup"
        >
            <form [formGroup]="ingestAllInvoicesFormGroup" [style.padding]="'2rem 3rem'">
                <p class="font-weight-400 text-black">
                    Allows LSQ to ingest invoices for relationships that are "SCF disabled"
                    (configurable on the Suppliers page or in the Suppliers file). These invoices
                    are disabled: visible internally to LSQ, but otherwise are not visible in any
                    FastTrack UI or report. To enable an invoice, a buyer must indicate in the
                    invoices file that it is to be paid to LSQ rather than the supplier.
                </p>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationIngestAllInvoicesComponent {
    @Input() public hasClickedSave: boolean;
    @Input() public ingestAllInvoicesFormGroup: FormGroup;
    public readonly icons = Icons;
    public readonly color = Color;
}
